import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { AtlassianLogo, ConfluenceLogo } from "@atlaskit/logo";
import { token } from "@atlaskit/tokens";
import { AccountSetupOverlay } from "@atlassian/confluence-account-setup";

const invisible = css({
    opacity: 0
});

export const CFind3467SignupBackgroundLayout = ({
    children
}: PropsWithChildren) => {
    return (
        <AccountSetupOverlay>
            <div css={containerStyles} data-testid="cfind-3467-signup-form">
                <div css={invisible} aria-hidden>
                    <AtlassianLogo size="small" />
                </div>
                <div css={formWrapperCss}>
                    <div css={productLogoContainerCss}>
                        <ConfluenceLogo size="small" appearance="brand" />
                    </div>
                    {children}
                </div>
                <div>
                    <AtlassianLogo
                        appearance="inverse"
                        size="small"
                        testId="atlassian-logo"
                        label="Atlassian logo"
                    />
                </div>
            </div>
        </AccountSetupOverlay>
    );
};

const containerStyles = css({
    display: "grid",
    gap: "25px",
    justifyItems: "center",
    gridTemplateRows: "auto 1fr auto",
    minHeight: "100vh",
    padding: "100px 0 100px"
});

const formWrapperCss = css({
    backgroundColor: token("elevation.surface"),
    borderRadius: "8px",
    boxShadow: token("elevation.shadow.overlay"),
    boxSizing: "content-box",
    margin: "0 auto",
    maxWidth: "calc(100vw - 2rem)",
    width: 400,
    padding: "40px 80px",
    minHeight: 520
});

const productLogoContainerCss = css({
    display: "flex",
    justifyContent: "center",
    marginBlockStart: "8px",
    marginBlockEnd: "16px"
});
